import React from "react";
import { useSelector } from "react-redux";
import dynamic from "next/dynamic";
import { IRepoV2ReduxState } from "repoV2/features/Common/modules/Reducer/Reducer.interface";
import { useCheckoutBasicDetailsContext } from "../CheckoutBasicDetailsContextProvider";
import { useExpressInterestContext } from "../CheckoutExpressInterestContextProider";
import { LimitedTimeOfferCardBaseProps } from "./modules/LimitedTimeOfferCardBase/LimitedTimeOfferCardBase.interfaces";

const LimitedTimeOfferCardBase = dynamic(
    () => import("./modules/LimitedTimeOfferCardBase/LimitedTimeOfferCardBase")
);

const LimitedTimeOfferCard = (props: LimitedTimeOfferCardBaseProps) => {
    const { listingExpired } = useExpressInterestContext();
    const { listingUuid } = useCheckoutBasicDetailsContext();

    const priceDetailsSection = useSelector(
        (state: IRepoV2ReduxState) =>
            state.checkoutPages.listingDetails[listingUuid]?.priceSection
    );
    const priceDetails = priceDetailsSection?.data || {};
    const {
        price_per_head: basePrice = 0, // price without any taxes, offers
        payable_amount: offerBasePrice = 0, // price with current offers(eg: LTO), without any taxes
    } = priceDetails;
    const ltoData = priceDetails.lto_data || {};

    const { time: endTime = 0 } = ltoData;

    const offValue = basePrice - offerBasePrice;

    // if: end time has passed
    //     OR the offer price is equal to the listing price
    //     OR listing has expired
    // the: no need to show the component AND run timer and and update state at every interval
    if (endTime <= Date.now() || offValue <= 0 || listingExpired) return null;

    return <LimitedTimeOfferCardBase {...props} />;
};

export default LimitedTimeOfferCard;
